// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .barchart .barchartDiv {
  display: block;
  /*border: 13px solid #F1F0F0;*/
  border-radius: 4px;
  clear: both;
  margin-left: -45px;
  width: 353px;
  box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);
  cursor: pointer;
  background-color: #ffffff;
}

.kore-chat-window .barchart .messageBubble.barchart {
  margin-bottom: 10px;
}

.kore-chat-window .barchart .profile-photo {
  top: 28px;
}

.kore-chat-window .barchartDiv .bar-chart-tooltip {
  position: absolute;
  max-width: 170px;
  padding: 2px;
  font: 12px sans-serif;
  background: #eed;
  border: 0px;
  border-radius: 8px;
  pointer-events: none;
}

.kore-chat-window .largePreviewContent .bar-chart-tooltip {
  position: absolute;
  padding: 2px;
  font: 12px sans-serif;
  background: #eed;
  border: 0px;
  border-radius: 8px;
  pointer-events: none;
  max-width: 200px;
}

.kore-chat-window .barChartChildDiv {
  margin-left: 13px;
  width: 340px;
}

[dir=rtl].kore-chat-window .piechart .piechartDiv {
  direction: ltr;
  margin-right: -45px;
}

[dir=rtl].kore-chat-window .barchart .barchartDiv {
  margin-right: -45px;
  direction: ltr;
}`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/barChartTemplate/barChartTemplate.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iDAAA;EACA,eAAA;EACA,yBAAA;AACJ;;AAEA;EACI,mBAAA;AACJ;;AAEA;EACI,SAAA;AACJ;;AACA;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;AAEJ;;AAAE;EACI,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;AAGN;;AADE;EACE,iBAAA;EACA,YAAA;AAIJ;;AAFE;EACE,cAAA;EACA,mBAAA;AAKJ;;AAFA;EACI,mBAAA;EACA,cAAA;AAKJ","sourcesContent":[".kore-chat-window .barchart .barchartDiv {\n    display: block;\n    /*border: 13px solid #F1F0F0;*/\n    border-radius: 4px;\n    clear: both;\n    margin-left: -45px;\n    width: 353px;\n    box-shadow: 0 1px 5px 0 rgba(179, 186, 200, 0.58);\n    cursor: pointer;\n    background-color: #ffffff;\n}\n\n.kore-chat-window .barchart .messageBubble.barchart {\n    margin-bottom: 10px;\n}\n\n.kore-chat-window .barchart .profile-photo {\n    top: 28px;\n}\n.kore-chat-window .barchartDiv .bar-chart-tooltip {\n    position: absolute;\n    max-width: 170px;\n    padding: 2px;\n    font: 12px sans-serif;\n    background: #eed;\n    border: 0px;\n    border-radius: 8px;\n    pointer-events: none;\n  }\n  .kore-chat-window  .largePreviewContent .bar-chart-tooltip {\n      position: absolute;\n      padding: 2px;\n      font: 12px sans-serif;\n      background: #eed;\n      border: 0px;\n      border-radius: 8px;\n      pointer-events: none;\n      max-width: 200px;\n  }\n  .kore-chat-window .barChartChildDiv {\n    margin-left: 13px;\n    width: 340px;\n}\n  [dir=\"rtl\"].kore-chat-window .piechart .piechartDiv{\n    direction: ltr;\n    margin-right: -45px;\n}\n\n[dir=\"rtl\"].kore-chat-window .barchart .barchartDiv{\n    margin-right: -45px;\n    direction: ltr; \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
